import { useTranslation } from "react-i18next";
import { PatientPackagesPanel } from "@/components/packages/PatientPackagesPanel";

interface MobilePetPackagesTabProps {
  ownerId: string | null;
  petId: string;
  clinicId: string | null;
  ownerName: string | null;
  petName: string;
}

export function MobilePetPackagesTab({
  ownerId,
  petId,
  clinicId,
  ownerName,
  petName,
}: MobilePetPackagesTabProps) {
  const { t } = useTranslation("patients");
  if (!ownerId || !clinicId) {
    return (
      <div className="bg-card border border-border/60 rounded-[20px] p-6 text-sm text-muted-foreground shadow-soft-card">
        {t("petProfile.packagesUnavailable")}
      </div>
    );
  }
  return (
    <PatientPackagesPanel
      ownerId={ownerId}
      petId={petId}
      clinicId={clinicId}
      ownerName={ownerName}
      petName={petName}
    />
  );
}
